const CustomMasonryHero = () => {
  return (
    <section className="relative bg-gradient-to-br from-gray-50 to-white pt-32 pb-20">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="inline-block bg-yellow-500 text-black px-4 py-2 rounded-full text-sm font-bold mb-6">
              CUSTOM CRAFTSMANSHIP
            </div>

            <h1 className="text-5xl lg:text-6xl font-bold text-black mb-6 leading-tight">
              Custom Masonry Solutions
            </h1>

            <p className="text-xl text-gray-700 mb-8 leading-relaxed">
              Tailored masonry services designed to meet your unique project requirements. From specialty finishes to complete restoration, we bring your vision to life with expert craftsmanship.
            </p>

            <div className="flex flex-wrap gap-4">
              <a
                href="#quote-form"
                className="bg-yellow-500 text-black px-8 py-4 rounded-lg font-bold hover:bg-yellow-400 transition-all cursor-pointer whitespace-nowrap"
              >
                REQUEST A QUOTE
              </a>
              <a
                href="tel:8282620000"
                className="bg-black text-white px-8 py-4 rounded-lg font-bold hover:bg-gray-800 transition-all cursor-pointer whitespace-nowrap flex items-center gap-2"
              >
                <i className="ri-phone-fill"></i>
                (828) 262-0000
              </a>
            </div>
          </div>

          <div className="relative">
            <div className="rounded-3xl overflow-hidden shadow-2xl border-4 border-yellow-500">
              <div className="w-full h-96">
                <img
                  src="https://public.readdy.ai/ai/img_res/f0e46beede9837efadae9afc0a931223.jpg"
                  alt="Custom Masonry Services"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CustomMasonryHero;